import { useEffect, useState } from "react";
import { fetchPreflight, PreflightParams, PreflightResponse } from "./preflightApi";

interface UsePreflightOptions {
  bulkOperationsUrl: string;
  params: PreflightParams;
  enabled: boolean;
}

interface UsePreflightResult {
  data: PreflightResponse | null;
  loading: boolean;
}

export function usePreflight({
  bulkOperationsUrl,
  params,
  enabled,
}: UsePreflightOptions): UsePreflightResult {
  const [data, setData] = useState<PreflightResponse | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setData(null);
      return;
    }

    let cancelled = false;
    setLoading(true);

    fetchPreflight(bulkOperationsUrl, params).then((result) => {
      if (!cancelled) {
        setData(result);
        setLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [enabled, bulkOperationsUrl, params.selection_mode, params.record_ids?.length, params.excluded_ids?.length]);

  return { data, loading };
}
